import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import './LegalPage.css';

interface PageData {
  slug: string;
  title: string;
  content: string;
  updated_at?: string;
}

const Imprint: React.FC = () => {
  const [page, setPage] = useState<PageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        const response = await api.get('/pages/imprint');
        setPage(response.data.page);
      } catch (err: any) {
        setError(err.response?.data?.error || 'Impressum konnte nicht geladen werden');
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, []);

  if (loading) {
    return <div className="legal-page"><p>Impressum wird geladen…</p></div>;
  }

  if (error) {
    return <div className="legal-page"><p className="legal-error">{error}</p></div>;
  }

  if (!page) {
    return <div className="legal-page"><p>Impressum nicht gefunden.</p></div>;
  }

  return (
    <div className="legal-page">
      <h1>{page.title}</h1>
      <div className="legal-content">
        {page.content.split('\n').map((line, idx) => (
          <p key={idx}>{line}</p>
        ))}
      </div>
      {page.updated_at && (
        <p className="legal-updated">
          Zuletzt aktualisiert am{' '}
          {new Date(page.updated_at).toLocaleDateString('de-DE')}
        </p>
      )}
    </div>
  );
};

export default Imprint;


